export const API_URL = process.env.REACT_APP_API_URL;
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL;

export const END_POINTS = {
  login: "admin/onboarding/login",
  forgotPassword: "admin/onboarding/send-otp",
  verifyOtp: "admin/onboarding/verify-otp",
  resetPassword: "admin/onboarding/change-password",
  changePassword: "admin/onboarding/change-password",
  getProfile: "admin/onboarding",
  updateProfile: "admin/onboarding",
  logout: "user/logout",

  // users
  users: "admin/users",
  editUser: "user/editUser",
  deleteUser: "user/deleteUser",
  getUsersById: "user/getUsersById",
  changeUserStatus: "admin/users/toggle-status",

  //cms
  cms: "admin/cms",
  faqList: "cms/listFaqs",
  faq: "admin/faq",

  //subAdmin & Roles
  subadminaccess: "subadminaccess",
  getSubAdmin: "subadminaccess/list",
  subadmin: "/user/subadmin",
  getsubAdmins: "/user/subadmins",

  //categories
  category: "admin/categories",

  //brands
  brands: "admin/brands/",
  addBrand: "admin/brands/add",

  //classes
  class: "admin/carClasses/",
  addClass: "admin/carClasses/add",

  //partner
  partner: "admin/partners",

  //vehicles
  vehicles: "admin/vehicles",
  addVehicles: "admin/vehicles/add",
  updateVechile: "/admin/vehicles",
  getVechile: "/admin/vehicles",

  //cities
  cities: "admin/cities",

  //Subscription
  subscription: "admin/subscription",
  deleteSubscription: "admin/users",

  //investment
  investment: "admin/investment",
  investmentList: "admin/investment/list",
  investmentListStatus: "admin/investment/update",
  updateInvestmentPlan: "admin/investment/update-plan",
  getInvestmentPlanById: "admin/investment/plan",
  agreementList: "admin/investment/agreement/list",
  addAgreement: "admin/investment/agreement/add",
  updateAgreement: "admin/investment/agreement/update",
  deleteAgreement: "admin/investment/agreement/delete",
  agreementDetails: "admin/investment/agreement/get",

  //bookings
  getBookings: "admin/booking",
};
